import { POPUP_OPEN, POPUP_CLOSE } from './types';

export const popupOpen = () => ({
    type: POPUP_OPEN,
});

export const popupClose = () => ({
    type: POPUP_CLOSE,
});
